var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeopleAlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "people_alt",
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4044",
    "data-name": "Group 4044"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5993",
    "data-name": "Rectangle 5993",
    width: 65,
    height: 65,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5994",
    "data-name": "Rectangle 5994",
    width: 65,
    height: 65,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4050",
    "data-name": "Group 4050",
    transform: "translate(2.708 10.833)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4049",
    "data-name": "Group 4049"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4045",
    "data-name": "Group 4045",
    transform: "translate(42.44 24.727)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4198",
    "data-name": "Path 4198",
    d: "M16.67,13.13c3.71,2.519,6.31,5.931,6.31,10.481v8.125h8.125a2.716,2.716,0,0,0,2.708-2.708V23.611C33.814,17.707,24.145,14.213,16.67,13.13Z",
    transform: "translate(-16.67 -13.13)",
    fill: "#374955",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4046",
    "data-name": "Group 4046",
    transform: "translate(10.833)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_85",
    "data-name": "Ellipse 85",
    cx: 10.833,
    cy: 10.833,
    r: 10.833,
    fill: "#374955"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4047",
    "data-name": "Group 4047",
    transform: "translate(34.315)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4199",
    "data-name": "Path 4199",
    d: "M17.272,25.667A10.833,10.833,0,0,0,17.272,4a11.316,11.316,0,0,0-3.6.65,16.2,16.2,0,0,1,0,20.367A11.316,11.316,0,0,0,17.272,25.667Z",
    transform: "translate(-13.67 -4)",
    fill: "#374955",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4048",
    "data-name": "Group 4048",
    transform: "translate(0 24.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4200",
    "data-name": "Path 4200",
    d: "M22.667,13C15.435,13,1,16.629,1,23.833V29.25a2.716,2.716,0,0,0,2.708,2.708H41.625a2.716,2.716,0,0,0,2.708-2.708V23.833C44.333,16.629,29.9,13,22.667,13Z",
    transform: "translate(-1 -13)",
    fill: "#374955",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleAlt);
export default __webpack_public_path__ + "static/media/people_alt.1079fbe79910f6cb882a4b23a8daf034.svg";
export { ForwardRef as ReactComponent };